import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './PaymentLinkPage.css';

const PaymentLinkPage = () => {
  const { linkId } = useParams();
  const navigate = useNavigate();
  const [link, setLink] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    fetchLinkDetails();
  }, [linkId]);

  const fetchLinkDetails = async () => {
    try {
      const response = await axios.get(`http://localhost:5000/api/payment-link/${linkId}`);
      
      if (response.data.success) {
        setLink(response.data.link);
        setFormData({
          name: response.data.link.customer_name || '',
          email: response.data.link.customer_email || '',
          phone: response.data.link.customer_phone || ''
        });
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired payment link');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setError('');

    try {
      const response = await axios.post(
        `http://localhost:5000/api/payment-link/${linkId}/pay`,
        formData
      );

      if (response.data.success && response.data.payment_url) {
        window.location.href = response.data.payment_url;
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Payment processing failed');
    } finally {
      setProcessing(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading payment details...</div>;
  }

  if (error) {
    return (
      <div className="payment-link-error">
        <h2>Payment Link Error</h2>
        <p>{error}</p>
        <button onClick={() => navigate('/')}>Go to Homepage</button>
      </div>
    );
  }

  return (
    <div className="payment-link-page">
      <div className="payment-link-container">
        <div className="payment-header">
          <h1>Complete Your Payment</h1>
          <p>Payment Link ID: {linkId}</p>
        </div>

        <div className="payment-details">
          <h2>{link.title}</h2>
          {link.description && <p className="description">{link.description}</p>}
          
          <div className="amount-box">
            <span className="amount-label">Amount to Pay:</span>
            <span className="amount-value">₹{link.amount}</span>
          </div>

          {link.expiry_date && (
            <p className="expiry-note">
              This link expires on: {new Date(link.expiry_date).toLocaleString()}
            </p>
          )}
        </div>

        <form onSubmit={handleSubmit} className="payment-form">
          <div className="form-group">
            <label>Your Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Enter your full name"
            />
          </div>

          <div className="form-group">
            <label>Email Address *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group">
            <label>Phone Number *</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder="Enter your phone number"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="pay-now-btn"
            disabled={processing}
          >
            {processing ? 'Processing...' : `Pay ₹${link.amount}`}
          </button>

          <p className="secure-note">
            <i className="fas fa-lock"></i>
            Secure payment powered by Easebuzz
          </p>
        </form>
      </div>
    </div>
  );
};

export default PaymentLinkPage;